var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"h-5 w-5 text-gray-400",attrs:{"fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","viewBox":"0 0 24 24","stroke":"currentColor"}},[_c('path',{attrs:{"d":"M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }